import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { assignParcoursMember, listParcoursMembers, unassignParcoursMember } from "../api/parcoursApi";
import { queryKeys } from "../lib/queryKeys";

export function useParcoursMembers(parcoursId: string) {
  return useQuery({
    queryKey: queryKeys.parcours.members(parcoursId),
    queryFn: () => listParcoursMembers(parcoursId),
    enabled: Boolean(parcoursId),
  });
}

export function useAssignParcoursMember(parcoursId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (memberId: string) => assignParcoursMember(parcoursId, memberId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.parcours.members(parcoursId) });
      qc.invalidateQueries({ queryKey: queryKeys.members.all });
    },
  });
}

export function useUnassignParcoursMember(parcoursId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (memberId: string) => unassignParcoursMember(parcoursId, memberId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.parcours.members(parcoursId) });
      qc.invalidateQueries({ queryKey: queryKeys.members.all });
    },
  });
}
